import React, { useEffect, useRef, useState } from 'react';
import './css/DocumentsTemplate.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import DocumentSubSection from './DocumentSubSection';
import { Collaborator } from 'app/types/collaborator';
import { DocumentsMap, typeDocument, TypeDocumentResponse } from 'app/types/documents';
import { toaster } from 'app/utilities/commons';
const API_URL = process.env.REACT_APP_API_NET;

type Props = {
  account: number;
  collaborator?: Collaborator;
  refetch: () => any;
};

const DocumentsTemplate: React.FC<Props> = ({
  account,
  collaborator,
  refetch,
}) => {
  const [selectedValue, setSelectedValue] = useState<any>('');
  const newFileRef = useRef<HTMLInputElement>(null);
  const [typeDocuments, setTypeDocuments] = useState<typeDocument[]>([]);
  const [reqDocuments, setReqDocuments] = useState<DocumentsMap[]>([]);
  const [notRequired, setNotRequired] = useState<DocumentsMap[]>([]);
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const res = await axios.get<TypeDocumentResponse>(`${API_URL}TypeDocuments`);
        setTypeDocuments(res.data.data.records);
      } catch (error) {
        console.error('Error al agarrar las posiciones:', error);
      }
    };
    fetchDocuments();
  }, []);

  useEffect(() => {
    if (collaborator?.documents && typeDocuments.length) {
      setReqDocuments(typeDocuments.filter((doc) => doc.isRequired
        || collaborator.documents.some((item) => item.typeDocumentId === doc.id))
        .map((doc) => ({
          ...doc,
          file: collaborator.documents.find((item) => item.typeDocumentId === doc.id),
        })));
      setNotRequired(typeDocuments.filter((doc) => !doc.isRequired && 
      !collaborator.documents.some((item) => item.typeDocumentId === doc.id)).map((doc) => ({
        ...doc,
        file: collaborator.documents.find((item) => item.typeDocumentId === doc.id),
      })));
    }
  }, [collaborator, typeDocuments]);

  const handleSelectChange = (event: any) => {
    setSelectedValue(event.target.value);
    newFileRef.current?.click();
  };

  const handleInputUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpload(selectedValue, e.target.files);
  };

  const handleUpload = async (typeDocumentId?: any, files?: FileList | null) => {
    const formData = new FormData();
    formData.append('file', files![0]);
    formData.append('CollaboratorId', account.toString());
    formData.append('TypeDocumentId', typeDocumentId);
    try {
      await axios.post(
        `${API_URL}Document`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      refetch();
      toast.success('Se subió correctamente el archivo');
    } catch (error) {
      toast.warning('Formatos válidos: xlsx, xlsm, txt, pdf, jpg, png');
      console.error('Error al subir el archivo:', error);
    }
  };

  const handleDelete = async (id: number | string) => {
    try {
      await axios.delete(
        `${API_URL}Document/${id}`
      );
      refetch();
      toaster.success('Se borró correctamente el archivo');
    } catch (error) {
      console.error('Error al borrar el archivo:', error);
      toaster.error('Hubo un error al eliminar el archivo');
    }
  };

  return (
    <>
      <div className="row mb-3 card-body pb-0">
        {reqDocuments.map((doc) => (
          <DocumentSubSection
            handleUpload={(files) => handleUpload(doc.id, files)}
            document={doc}
            handleDelete={handleDelete}
          />
        ))}
      </div>
      <div className="card-body pt-0">
        <select
          value=""
          onChange={handleSelectChange}
          className="form-select alert-dark"
        >
          <option value="" disabled>
            Seleccione el Documento Opcional
          </option>
          {notRequired.map((doc) => (
            <option key={`option-${doc.id}`} value={doc.id}>
              {doc.description}
            </option>
          ))}
        </select>
        <input
          className="d-none"
          type="file"
          name="documentos"
          ref={newFileRef}
          accept=".xlsx, .xlsm, .txt, .pdf, .jpg, .png"
          onChange={handleInputUpload}
        />
      </div>
    </>
  );
};

export { DocumentsTemplate };
